export const blockIconsTextformattingFolderOpenNew = (
	<span className='material-symbols-outlined'>folder_open</span>
);
